<ng-container *ngIf="phase != null">
    <div class="barra">
        <options class="show-label" [optionstrip]="options" (clickOption)="clickOption($event)"></options>
        <actions [actionstrip]="actions" (clickAction)="clickAction($event)">
        </actions>
    </div>
    <shared-sign *ngIf="uuid && agent && optionSelected != 'QR'" [uuid]="uuid" [agent]="agent" (signedChanged)="onSignedChanged()"></shared-sign>
    <shared-phase-cmr-qr-component *ngIf="optionSelected == 'QR'" [phaseUUID]="uuid"></shared-phase-cmr-qr-component>
</ng-container>